import { render, staticRenderFns } from "./QuickActionCard.vue?vue&type=template&id=3f00f805&scoped=true&lang=pug"
import script from "./QuickActionCard.vue?vue&type=script&lang=js"
export * from "./QuickActionCard.vue?vue&type=script&lang=js"
import style0 from "./QuickActionCard.vue?vue&type=style&index=0&id=3f00f805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00f805",
  null
  
)

export default component.exports